<script setup lang="ts">
import { ref, onMounted } from "vue";

import type { TToScene, TFromScene } from "./protocol";

const props = defineProps<{ src?: string }>();
const emit = defineEmits<{
    (e: "images", data: Record<string, string>): void;
    (e: "camera", data: unknown): void;
}>();

const iframeRef = ref<HTMLIFrameElement | null>(null);

function post(msg: TToScene) {
    console.log("Posting message to iframe:", msg);
    const win = iframeRef.value?.contentWindow;
    if (!win) { return; }
    win.postMessage(JSON.stringify(msg), window.location.origin);
}

onMounted(() => {
    window.addEventListener("message", (ev: MessageEvent<TFromScene>) => {
        if (ev.origin !== window.location.origin) { return; }
        const m = ev.data;
        if (!m || typeof m !== "object") { return; }
        if (m.type === "ReceiveImagesFromPixi") { emit("images", m.payload); }
        if (m.type === "changeCamera") { emit("camera", m.payload.cameraData); }
    });
});

defineExpose({
    update: (json: string) => { post(json); },
    screenshot: () => { post({ type: "askForImages", image_name: "imageLowRez", width: 300, height: 300 }); },
    screenshotHighRez: () => { post({ type: "askForImagesHighRez", image_name: "imageHighRez" }); },
});
</script>

<template>
    <div class="iframe-wrap">
        <iframe
            ref="iframeRef"
            class="iframe-el"
            :src="props.src ?? '/scene.html'"
        />
    </div>
</template>

<style scoped>
.iframe-wrap {
  width: 100%;
  height: 100%;
  min-height: 0; /* crucial in grid/flex layouts */
  overflow: hidden;
}
.iframe-el {
  width: 100%;
  height: 100%;
  display: block; /* removes default inline-gap */
    border: 0;
}
</style>
